<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">View List of Pages</div>
      <div class="d-flex">
        <div>
          <router-link
            v-if="
              $can('create', 'List Of Pages') ||
              $can('create', 'View List of Pages')
            "
            class="btn-blue"
            :to="'/reports/list-of-pages'"
            >{{ $t("Add") }}</router-link
          >
        </div>
        <div class="mx-2">
          <button class="btn-blue">
            Viewing {{ viewingStart }} to {{ viewingEnd }} of
            {{ pagesData.length }}
          </button>
        </div>
      </div>
    </div>
    <div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <table class="list-view-table">
              <thead>
                <tr>
                  <th style="width: 20px"></th>
                  <th style="width: 200px">Page Name</th>
                  <th>Language</th>
                </tr>
              </thead>
              <tbody v-if="pagesData.length > 0">
                <tr v-for="(item, index) in pagesData" :key="index">
                  <td class="text-left">
                    <i
                      v-if="
                        $can('update', 'List Of Pages') ||
                        $can('update', 'View List of Pages')
                      "
                      class="edit-pen icon blue-icon cursor-pointer"
                      @click.prevent.stop="
                        goToRoute('/reports/list-of-pages/', item)
                      "
                      v-b-tooltip="'Edit'"
                      tabindex="0"
                    ></i>
                  </td>

                  <td>{{ item.mpm_name }}</td>
                  <td>{{ item.lang_name }}</td>
                  <!-- <td class="text-right">
                    <b-dropdown
                      right
                      variant="edit"
                      class="ml-4"
                      v-if="
                        $can('update', 'List Of Pages') ||
                          $can('update', 'View List of Pages')
                      "
                    >
                      <b-dropdown-item
                        @click="goToRoute('/reports/list-of-pages/', item)"
                      >
                        <span class="edit-pen"></span>
                        {{ $t("edit") }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </td> -->
                </tr>
              </tbody>
              <tbody v-if="pagesData.length == 0">
                <tr>
                  <td colspan="3">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExhibitorService from "@/services/ExhibitorService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  name: "View List of Pages",
  components: {
    StatusDot,
    NoRecords,
  },
  data() {
    return {
      pagesData: [],
      itemsPerPage: 10,
      currentPage: 1,
    };
  },
  beforeMount() {
    this.getListOfPages();
  },
  computed: {
    viewingStart() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    viewingEnd() {
      const end = this.currentPage * this.itemsPerPage;
      return end > this.pagesData.length ? this.pagesData.length : end;
    },
  },
  methods: {
    getListOfPages() {
      ExhibitorService.GetListOfPages()
        .then((response) => {
          const { data } = response;
          if (data.Records.length > 0) {
            console.log(data.Records);
            // this.pagesData = data.Records;
            let pageData = data.Records;
            this.pagesData = pageData
              .filter(
                (x, index, self) =>
                  index ===
                  self.findIndex(
                    (t) =>
                      t.mpm_name === x.mpm_name &&
                      t.mpm_lang_id === x.mpm_lang_id
                  )
              )
              .sort((a, b) => {
                let comparison = 0;
                const nameA = a.mpm_name.toUpperCase();
                const nameB = b.mpm_name.toUpperCase();

                if (nameA < nameB) comparison = -1;
                if (nameA > nameB) comparison = 1;

                if (comparison == 0)
                  comparison =
                    (parseInt(b.mpm_lang_id || 0) || 0) -
                    (parseInt(a.mpm_lang_id || 0) || 0);

                return comparison;
              });
          } else {
            console.log("data.message", data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToRoute: function (path, item) {
      const { mpm_id } = item;
      this.$router.push({
        path: path,
        query: {
          mpm_id: mpm_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/viewListOfPages.vue